import { render, staticRenderFns } from "./DaftarSertifikatPenelitiKeamanan.vue?vue&type=template&id=1b27632f&scoped=true&"
import script from "./DaftarSertifikatPenelitiKeamanan.vue?vue&type=script&lang=js&"
export * from "./DaftarSertifikatPenelitiKeamanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b27632f",
  null
  
)

export default component.exports